<!-- src\components\locales\LocalesView.vue -->
<template>
  <div class="min-h-screen bg-efintelwhite-50">

    <div class="bg-white border-b border-gray-200">
      <div class="px-6 py-6">
        <nav class="flex items-center space-x-2 text-sm mb-4">
          <button @click="$emit('back-to-empresas')" class="flex items-center space-x-1 text-blue-600 hover:text-blue-800 transition-colors">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
            </svg>
            <span>Volver a Empresas</span>
          </button>
        </nav>
        <div v-if="mensajePermisos" class="bg-blue-50 border-l-4 border-blue-500 rounded-lg p-3 mb-4">
          <div class="flex items-center">
            <svg class="w-5 h-5 text-blue-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
            <p class="text-sm text-blue-800 font-medium">{{ mensajePermisos }}</p>
          </div>
        </div>
        <div class="flex items-center justify-between">
          <div class="flex items-center space-x-4">
            <div class="w-16 h-16 rounded-xl flex items-center justify-center">
              <img v-if="empresa.media" :src="empresa.media" class="w-full h-full object-cover" alt="Logo">
            </div>

            <div>
              <h1 class="text-3xl font-bold text-gray-900">{{ empresaNombre }}</h1>
              <p class="text-gray-600 mt-1">Gestiona los locales y sus dispositivos</p>

              <div class="flex items-center space-x-4 mt-2 text-sm text-gray-500">
                <span>{{ localesFiltrados.length }} de {{ estadisticas.total }} {{ estadisticas.total === 1 ? 'local' : 'locales' }} mostrados</span>

                <span v-if="estadisticas.conEncargado > 0" class="flex items-center space-x-1">
                  <svg class="w-4 h-4 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                  </svg>
                  <span>{{ estadisticas.conEncargado }} con encargado</span>
                </span>

                <span v-if="estadisticas.sinEncargado > 0" class="flex items-center space-x-1">
                  <svg class="w-4 h-4 text-amber-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.732 15.5c-.77.833.192 2.5 1.732 2.5z"></path>
                  </svg>
                  <span>{{ estadisticas.sinEncargado }} sin encargado</span>
                </span>
              </div>
            </div>
          </div>
          <div class="flex space-x-4">
            <button v-if="puedeCrearLocales" @click="showCreateForm" class="bg-white text-center text-sm w-32 rounded-xl h-10 relative text-black font-medium group border border-emerald-600 hover:emerald-600 transition-all duration-300 overflow-hidden" type="button">
              <div class="flex items-center justify-center h-full relative z-10 transition-all duration-300 group-hover:text-white">
                <svg class="w-4 h-4 mr-1.5 transition-all duration-300 group-hover:scale-110" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
                </svg>
                <span>Crear Local</span>
              </div>
              <div class="absolute inset-0 bg-emerald-600 rounded-xl transform scale-x-0 origin-left group-hover:scale-x-100 transition-transform duration-300 ease-out"></div>
            </button>
            <button @click="loadLocales" class="bg-white text-center text-sm w-32 rounded-xl h-10 relative text-black font-medium group border border-blue-600 hover:border-blue-500 transition-all duration-300 overflow-hidden" type="button">
              <div class="flex items-center justify-center h-full relative z-10 transition-all duration-300 group-hover:text-white">
                <svg :class="['w-4 h-4 mr-1.5 transition-all duration-300 group-hover:scale-110', isLoading ? 'animate-spin' : '']" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
                </svg>
                <span>{{ isLoading ? 'Cargando...' : 'Actualizar' }}</span>
              </div>
              <div class="absolute inset-0 bg-blue-500 rounded-xl transform scale-x-0 origin-left group-hover:scale-x-100 transition-transform duration-300 ease-out"></div>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="bg-gray-50 border-gray-200 px-4 py-3 flex-shrink-0">
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
        <!-- Búsqueda: ocupa 2 columnas en desktop y en móvil también 2 -->
        <div class="sm:col-span-2 lg:col-span-2">
          <div class="relative">
            <input v-model="searchText" type="text" placeholder="Buscar por numero de local, encargado, dirección..." class="w-full pl-9 pr-9 h-9 text-sm border border-gray-300 rounded-lg bg-white shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors" />
            <svg class="absolute left-3 top-2.5 w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
            <button v-if="searchText" @click="searchText = ''" class="absolute right-3 top-2.5 text-gray-400 hover:text-gray-600">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>

        <!-- Dropdown Estado -->
        <div>
          <div class="relative">
            <button @click="toggleDropdown('estado')" class="w-full h-9 px-3 text-sm bg-white border border-gray-300 rounded-lg shadow-sm hover:border-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors text-left flex items-center justify-between">
              <span class="text-gray-700 truncate">
                {{ selectedStatus
                  ? (selectedStatus === 'operativo' ? 'Operativo'
                    : selectedStatus === 'advertencia' ? 'Advertencia'
                      : selectedStatus === 'error' ? 'Error'
                        : 'Sin dispositivos')
                  : 'Todos' }}
              </span>
              <svg :class="['w-4 h-4 text-gray-400 transition-transform', dropdownOpen.estado ? 'rotate-180' : '']" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
            </button>

            <div v-if="dropdownOpen.estado" class="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg overflow-hidden">
              <button @click="selectOption('estado', '')" class="w-full px-3 py-2 text-sm text-left hover:bg-gray-50 transition-colors">
                Todos
              </button>
              <button @click="selectOption('estado', 'operativo')" class="w-full px-3 py-2 text-sm text-left hover:bg-gray-50 transition-colors">
                Operativo
              </button>
              <button @click="selectOption('estado', 'advertencia')" class="w-full px-3 py-2 text-sm text-left hover:bg-gray-50 transition-colors">
                Advertencia
              </button>
              <button @click="selectOption('estado', 'error')" class="w-full px-3 py-2 text-sm text-left hover:bg-gray-50 transition-colors">
                Error
              </button>
              <button @click="selectOption('estado', 'sin dispositivos')" class="w-full px-3 py-2 text-sm text-left hover:bg-gray-50 transition-colors">
                Sin dispositivos
              </button>
            </div>
          </div>
        </div>

        <!-- Dropdown Encargado -->
        <div>
          <div class="relative">
            <button @click="toggleDropdown('encargado')" class="w-full h-9 px-3 text-sm bg-white border border-gray-300 rounded-lg shadow-sm hover:border-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors text-left flex items-center justify-between">
              <span class="text-gray-700 truncate">
                {{ selectedEncargado
                  ? (selectedEncargado === 'sin_encargado' ? 'Sin encargado' : 'Con encargado')
                  : 'Todos' }}
              </span>
              <svg :class="['w-4 h-4 text-gray-400 transition-transform', dropdownOpen.encargado ? 'rotate-180' : '']" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
            </button>

            <div v-if="dropdownOpen.encargado" class="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg overflow-hidden">
              <button @click="selectOption('encargado', '')" class="w-full px-3 py-2 text-sm text-left hover:bg-gray-50 transition-colors">
                Todos
              </button>
              <button @click="selectOption('encargado', 'sin_encargado')" class="w-full px-3 py-2 text-sm text-left hover:bg-gray-50 transition-colors">
                Sin encargado
              </button>
              <button @click="selectOption('encargado', 'con_encargado')" class="w-full px-3 py-2 text-sm text-left hover:bg-gray-50 transition-colors">
                Con encargado
              </button>
            </div>
          </div>
        </div>

        <!-- Columna vacía en lg para mantener el grid de 4, pero el contador va aparte -->
        <div class="hidden lg:block"></div>
      </div>

      <!-- Contador y limpiar filtros (fuera del grid para mejor control) -->
      <div class="flex justify-end px-1 text-xs text-gray-500">
        <div class="flex items-center space-x-2">
          <span>Se muestran <span class="font-medium text-gray-700">{{ localesFiltrados.length }}</span> resultados</span>
          <button v-if="hasActiveFilters" @click="clearAllFilters" class="text-red-600 hover:text-red-800 underline font-medium transition-colors">
            Limpiar filtros
          </button>
        </div>
      </div>
    </div>

    <div class="px-5">
      <div v-if="isLoading" class="bg-white rounded-lg border border-gray-200 overflow-hidden">
        <div class="animate-pulse">
          <div class="bg-gray-50 px-6 py-3 border-b border-gray-200">
            <div class="grid grid-cols-6 gap-4">
              <div class="h-4 bg-gray-300 rounded"></div>
              <div class="h-4 bg-gray-300 rounded"></div>
              <div class="h-4 bg-gray-300 rounded"></div>
              <div class="h-4 bg-gray-300 rounded"></div>
              <div class="h-4 bg-gray-300 rounded"></div>
              <div class="h-4 bg-gray-300 rounded"></div>
            </div>
          </div>
          <div v-for="n in 5" :key="n" class="px-6 py-4 border-b border-gray-200">
            <div class="grid grid-cols-6 gap-4 items-center">
              <div class="flex items-center space-x-3">
                <div class="w-8 h-8 bg-gray-300 rounded"></div>
                <div class="h-4 bg-gray-300 rounded w-16"></div>
              </div>
              <div class="h-4 bg-gray-300 rounded w-24"></div>
              <div class="h-4 bg-gray-300 rounded w-32"></div>
              <div class="h-4 bg-gray-300 rounded w-20"></div>
              <div class="h-4 bg-gray-300 rounded w-48"></div>
              <div class="h-4 bg-gray-300 rounded w-20"></div>
            </div>
          </div>
        </div>
      </div>

      <div v-else-if="locales.length > 0 && localesFiltrados.length === 0" class="bg-white rounded-lg border border-gray-200 p-12 text-center">
        <div class="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg class="w-12 h-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
          </svg>
        </div>
        <h3 class="text-lg font-medium text-gray-900 mb-2">No se encontraron locales</h3>
        <p class="text-gray-600 mb-4">No hay locales que coincidan con los filtros aplicados</p>
        <button @click="clearAllFilters" class="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors">
          Limpiar Filtros
        </button>
      </div>

      <div v-else-if="localesFiltrados.length > 0" class="bg-white rounded-lg border border-gray-200 overflow-hidden">
        <div class="overflow-x-auto">
          <table class="min-w-full">
            <thead class="bg-gray-50">
              <tr>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Logo/Formato
                </th>
                <th @click="sortBy('numero_local')" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  <div class="flex items-center space-x-1">
                    <span>N° de Local</span>
                    <svg v-if="sortColumn === 'numero_local'" :class="{ 'rotate-180': sortDirection === 'desc' }" class="w-4 h-4 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7"></path>
                    </svg>
                  </div>
                </th>
                <th @click="sortBy('encargado')" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  <div class="flex items-center space-x-1">
                    <span>Encargado</span>
                    <svg v-if="sortColumn === 'encargado'" :class="{ 'rotate-180': sortDirection === 'desc' }" class="w-4 h-4 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7"></path>
                    </svg>
                  </div>
                </th>
                <th @click="sortBy('estado')" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  <div class="flex items-center space-x-1">
                    <span>Estado</span>
                    <svg v-if="sortColumn === 'estado'" :class="{ 'rotate-180': sortDirection === 'desc' }" class="w-4 h-4 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7"></path>
                    </svg>
                  </div>
                </th>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Dirección
                </th>
                <th class="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Acciones
                </th>
              </tr>
            </thead>

            <tbody class="bg-white divide-y divide-gray-200">
              <tr v-for="(local, index) in localesSorted" :key="local.id" @click="selectLocal(local)" class="hover:bg-blue-50 transition-colors duration-150 cursor-pointer">

                <td class="px-6 py-4 whitespace-nowrap">
                  <div class="flex items-center">
                    <div class="w-12 h-8 rounded flex items-center justify-center mr-3 border border-gray-200 overflow-hidden">
                      <img v-if="local.media" :src="getImageUrl(local.media)" :alt="`Logo ${local.numero_local}`" class="w-full h-full object-cover" @error="handleImageError($event, local)" />
                      <div v-else :style="{ backgroundColor: getEmpresaColor() }" class="w-full h-full flex items-center justify-center">
                        <span class="text-white text-xs font-bold">{{ getLogoText(local) }}</span>
                      </div>
                    </div>
                  </div>
                </td>

                <td class="px-6 py-4 whitespace-nowrap">
                  <div class="text-sm font-medium text-gray-900">
                    {{ local.numero_local }}
                  </div>
                </td>

                <td class="px-6 py-4">
                  <div v-if="local.id_encargado && local.encargado !== 'Sin asignar'" class="text-sm text-gray-900">
                    {{ local.encargado }}
                  </div>
                  <div v-else class="text-sm text-gray-500 italic">
                    Sin encargado asignado
                  </div>

                  <div v-if="local.id_encargado && local.encargado_email" class="text-xs text-gray-500">
                    {{ local.encargado_email }}
                  </div>

                  <div v-if="!local.id_encargado" class="flex items-center mt-1">
                    <svg class="w-3 h-3 text-amber-500 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.732 15.5c-.77.833.192 2.5 1.732 2.5z"></path>
                    </svg>
                    <span class="text-xs text-amber-600">Disponible para asignar</span>
                  </div>
                </td>

                <td class="px-6 py-4 whitespace-nowrap">
                  <span :class="[
                    'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium',
                    getStatusClasses(local)
                  ]">
                    <svg :class="[
                      'w-1.5 h-1.5 mr-1.5',
                      getStatusIconColor(local)
                    ]" fill="currentColor" viewBox="0 0 8 8">
                      <circle cx="4" cy="4" r="3"></circle>
                    </svg>
                    {{ getLocalStatus(local) }}
                  </span>
                </td>

                <td class="px-6 py-4">
                  <div class="flex items-center">
                    <svg class="w-4 h-4 text-red-500 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
                    </svg>
                    <div class="text-sm text-gray-900 max-w-xs truncate">
                      {{ local.direccion }}
                    </div>
                  </div>
                </td>

                <td class="px-4 py-2 whitespace-nowrap">
                  <div class="flex items-center text-center">
                    <div class="relative">
                      <button v-if="puedeEditarLocales || puedeEliminarLocales" @click.stop="toggleSecondaryMenu(local.id)" class="group p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-50 rounded-lg transition-all duration-200" title="Más opciones">
                        <svg class="w-5 h-5 transition-transform duration-200 group-hover:rotate-90" fill="currentColor" viewBox="0 0 20 20">
                          <path d="M6 10a2 2 0 11-4 0 2 2 0 014 0zM12 10a2 2 0 11-4 0 2 2 0 014 0zM16 12a2 2 0 100-4 2 2 0 000 4z" />
                        </svg>
                      </button>

                      <div v-if="activeSecondaryMenu === local.id" :class="[
                        'absolute right-0 w-44 bg-white rounded-lg shadow-lg border border-gray-200 z-20 transform transition-all duration-200',
                        index >= localesSorted.length - 2 ? 'bottom-full mb-2 origin-bottom-right' : 'mt-2 origin-top-right'
                      ]">

                        <button @click.stop="editLocal(local); closeSecondaryMenus()" class="group flex items-center w-full px-4 py-3 text-sm text-gray-700 hover:bg-yellow-50 hover:text-yellow-700 transition-colors duration-150 first:rounded-t-lg">
                          <svg class="w-4 h-4 mr-3 transition-transform duration-200 group-hover:scale-110" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                          </svg>
                          Editar Local
                        </button>

                        <hr class="border-gray-100">

                        <button @click.stop="iniciarEliminacionLocal(local); closeSecondaryMenus()" class="group flex items-center w-full px-4 py-3 text-sm text-red-600 hover:bg-red-50 hover:text-red-700 transition-colors duration-150 last:rounded-b-lg">
                          <svg class="w-4 h-4 mr-3 transition-transform duration-200 group-hover:scale-110" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                          </svg>
                          Eliminar Local
                        </button>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div v-else class="bg-white rounded-lg border border-gray-200 p-12 text-center">
        <div class="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg class="w-12 h-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"></path>
          </svg>
        </div>
        <h3 class="text-lg font-medium text-gray-900 mb-2">No hay locales registrados</h3>
        <p class="text-gray-600 mb-6">{{ empresaNombre }} aún no tiene locales registrados</p>

        <button v-if="puedeCrearLocales" @click="showCreateForm" class="mx-auto bg-white text-center text-sm w-48 rounded-xl h-10 relative text-black font-medium group border border-emerald-600 hover:border-emerald-600 transition-all duration-300 overflow-hidden block" type="button">
          <div class="flex items-center justify-center h-full relative z-10 transition-all duration-300 group-hover:text-white">
            <svg class="w-4 h-4 mr-1.5 transition-all duration-300 group-hover:scale-110" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
            </svg>
            <span>Crear Primer Local</span>
          </div>
          <div class="absolute inset-0 bg-emerald-600 rounded-xl transform scale-x-0 origin-left group-hover:scale-x-100 transition-transform duration-300 ease-out"></div>
        </button>
      </div>
    </div>

    <div v-if="showLocalModal" class="fixed inset-0 flex items-center justify-center z-70 p-3 sm:p-4 bg-gray-900/60 backdrop-blur-sm">
      <div class="bg-white rounded-lg w-full max-w-full sm:max-w-[95vw] md:max-w-[60rem] max-h-[95vh] sm:max-h-[90vh] overflow-hidden flex flex-col mx-auto">

        <div :class="[
          'text-white p-3 sm:p-4 rounded-t-lg flex-shrink-0',
          isEditMode ? 'bg-gradient-to-r from-yellow-600 to-yellow-700' : 'bg-gradient-to-r from-emerald-600 to-emerald-700'
        ]">
          <div class="flex items-center justify-between gap-2">
            <div class="flex items-center gap-2 sm:gap-3 min-w-0 flex-1">
              <div :class="[
                'w-8 h-8 sm:w-10 sm:h-10 rounded-full flex items-center justify-center flex-shrink-0',
                isEditMode ? 'bg-yellow-500' : 'bg-emerald-500'
              ]">
                <svg class="w-4 h-4 sm:w-5 sm:h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path v-if="isEditMode" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path>
                  <path v-else stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"></path>
                </svg>
              </div>
              <div class="min-w-0 flex-1">
                <h3 class="text-base sm:text-lg md:text-xl font-bold truncate">
                  {{ isEditMode ? 'Editar Local' : 'Crear Nuevo Local' }}
                </h3>
                <p :class="isEditMode ? 'text-yellow-100' : 'text-emerald-100'" class="text-xs sm:text-sm truncate">
                  {{ empresaNombre }}{{ isEditMode ? ` - Local ${localForm.numero_local}` : '' }}
                </p>
              </div>
            </div>
            <button @click="hideLocalModal" :class="[
              'w-8 h-8 sm:w-10 sm:h-10 rounded-full flex items-center justify-center transition-colors flex-shrink-0',
              isEditMode ? 'bg-yellow-500 hover:bg-yellow-600' : 'bg-emerald-500 hover:bg-emerald-600'
            ]">
              <svg class="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
              </svg>
            </button>
          </div>
        </div>

        <div class="overflow-y-auto flex-1 p-4 sm:p-5 md:p-6">
          <form @submit.prevent="submitLocalForm" class="space-y-4 sm:space-y-5">

            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">

              <div>
                <label class="block text-sm font-medium text-gray-700 mb-1.5">
                  Número de Local <span class="text-red-500">*</span>
                </label>
                <input v-model="localForm.numero_local" type="text" required :disabled="processingLocal" class="w-full px-3 py-2.5 text-sm sm:text-base border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors disabled:opacity-50 disabled:bg-gray-100" placeholder="001">
              </div>

              <div>
                <label class="block text-sm font-medium text-gray-700 mb-1.5">
                  Encargado
                  <span class="text-gray-500 text-xs font-normal">(Opcional)</span>
                </label>
                <select v-model="localForm.id_encargado" :disabled="processingLocal || loadingEncargados" class="w-full px-3 py-2.5 text-sm sm:text-base border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors disabled:opacity-50 disabled:bg-gray-100 bg-white">

                  <option value="">
                    {{ loadingEncargados ? 'Cargando encargados...' : '-- Sin encargado asignado --' }}
                  </option>

                  <option v-for="encargado in encargadosDisponibles" :key="encargado.id" :value="encargado.id">
                    {{ encargado.nombre_completo }} ({{ encargado.email }})
                  </option>
                </select>

                <p class="text-xs text-gray-500 mt-1.5">
                  Puedes crear el local sin encargado y asignarlo posteriormente
                </p>
              </div>
            </div>

            <div>
              <label class="block text-sm font-medium text-gray-700 mb-1.5">
                Dirección <span class="text-red-500">*</span>
              </label>
              <input v-model="localForm.direccion" type="text" required :disabled="processingLocal" class="w-full px-3 py-2.5 text-sm sm:text-base border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors disabled:opacity-50 disabled:bg-gray-100" placeholder="Av. Principal 123, Santiago Centro">
            </div>

            <div class="grid grid-cols-1 lg:grid-cols-2 gap-2 sm:gap-3 items-stretch">
              <div class="border border-gray-200 rounded-lg p-2.5 sm:p-3 bg-gray-50 flex flex-col">
                <h4 class="text-sm font-semibold text-gray-900 mb-2 flex items-center">
                  <svg class="w-4 h-4 mr-1.5 text-blue-600 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                  </svg>
                  Logo del Local
                </h4>

                <div class="relative flex-1 flex flex-col items-center justify-center border-2 border-dashed border-gray-300 rounded-lg bg-white p-2 hover:bg-blue-50/50 hover:border-blue-400 transition-colors duration-75 text-center group min-h-[140px]">
                  <input ref="fileInput" type="file" accept="image/*" @change="handleFileSelect" :disabled="processingLocal" class="absolute inset-0 w-full h-full opacity-0 cursor-pointer disabled:cursor-not-allowed z-10" title="Arrastra tu logo o haz clic">

                  <div class="h-16 sm:h-20 flex items-center justify-center mb-2 w-full pointer-events-none">
                    <img v-if="imagePreview || (isEditMode && currentImageUrl)" :src="imagePreview || currentImageUrl" alt="Preview" class="max-h-full max-w-full object-contain drop-shadow-sm rounded" />
                    <div v-else class="flex flex-col items-center text-gray-400 group-hover:text-blue-500 transition-colors">
                      <svg class="w-8 h-8 mb-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                      </svg>
                      <p class="text-xs font-medium">Arrastra o explora</p>
                    </div>
                  </div>

                  <span class="text-[10px] font-medium px-3 py-1 rounded-full truncate max-w-[90%] relative z-0 transition-colors" :class="selectedFile || (isEditMode && currentImageUrl) ? 'bg-blue-100 text-blue-700' : 'bg-gray-100 text-gray-600'">
                    {{ selectedFile ? selectedFile.name : (isEditMode && currentImageUrl ? 'Cambiar Logo' : 'Seleccionar logo') }}
                  </span>
                </div>

                <div class="flex justify-center gap-2 mt-2 min-h-[20px]">
                  <button v-if="selectedFile" type="button" @click="clearSelectedFile" :disabled="processingLocal" class="text-[11px] text-red-600 hover:text-red-800 disabled:opacity-50 flex items-center">
                    <svg class="w-3 h-3 mr-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
                    </svg>
                    Quitar
                  </button>
                  <button v-if="isEditMode && currentImageUrl && !imageRemoved" type="button" @click="removeCurrentImage" :disabled="processingLocal" class="text-[11px] text-orange-600 hover:text-orange-800 disabled:opacity-50 flex items-center">
                    <svg class="w-3 h-3 mr-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                    </svg>
                    Eliminar actual
                  </button>
                  <span v-if="imageRemoved" class="text-[10px] text-gray-500 italic">Será eliminado</span>
                </div>
              </div>

              <div class="border border-gray-200 rounded-lg p-2.5 sm:p-3 bg-gray-50 flex flex-col">
                <h4 class="text-sm font-semibold text-gray-900 mb-2 flex items-center">
                  <svg class="w-4 h-4 mr-1.5 text-indigo-600 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                  </svg>
                  Plano del Local
                </h4>

                <div class="relative flex-1 flex flex-col items-center justify-center border-2 border-dashed border-indigo-200 rounded-lg bg-white p-2 hover:bg-indigo-50 hover:border-indigo-400 transition-colors duration-75 text-center group min-h-[140px]">
                  <input ref="planoInput" type="file" accept="image/*" @change="handlePlanoSelect" :disabled="processingLocal" class="absolute inset-0 w-full h-full opacity-0 cursor-pointer disabled:cursor-not-allowed z-10" title="Arrastra tu plano o haz clic">

                  <div class="h-16 sm:h-20 flex items-center justify-center mb-2 w-full pointer-events-none">
                    <img v-if="planoPreview" :src="planoPreview" alt="Preview Plano" class="max-h-full max-w-full object-contain drop-shadow-sm rounded" />
                    <div v-else class="flex flex-col items-center text-indigo-300 group-hover:text-indigo-500 transition-colors">
                      <svg class="w-8 h-8 mb-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"></path>
                      </svg>
                      <p class="text-xs font-medium">Arrastra el esquema</p>
                    </div>
                  </div>

                  <span class="text-[10px] font-medium px-3 py-1 rounded-full truncate max-w-[90%] relative z-0 transition-colors" :class="selectedPlanoFile ? 'bg-indigo-100 text-indigo-700' : 'bg-gray-100 text-gray-600'">
                    {{ selectedPlanoFile ? selectedPlanoFile.name : (isEditMode ? 'Actualizar' : 'Seleccionar plano') }}
                  </span>
                </div>

                <div class="flex items-center justify-between mt-2 gap-2">
                  <div class="flex flex-1 gap-2 bg-white p-1.5 rounded border border-gray-200 shadow-sm">
                    <div class="flex-1 flex items-center justify-between px-1">
                      <label class="text-[10px] font-bold text-gray-600 mr-1">Filas</label>
                      <input v-model.number="localForm.plano_filas" type="number" min="1" max="100" class="w-12 px-1 py-0.5 text-xs font-medium border border-gray-300 rounded focus:ring-indigo-500 text-center">
                    </div>
                    <div class="w-px bg-gray-200"></div>
                    <div class="flex-1 flex items-center justify-between px-1">
                      <label class="text-[10px] font-bold text-gray-600 mr-1">Cols</label>
                      <input v-model.number="localForm.plano_columnas" type="number" min="1" max="100" class="w-12 px-1 py-0.5 text-xs font-medium border border-gray-300 rounded focus:ring-indigo-500 text-center">
                    </div>
                  </div>

                  <div class="flex items-center gap-2">
                    <button v-if="selectedPlanoFile" type="button" @click="clearSelectedPlano" :disabled="processingLocal" class="text-[11px] px-2 text-red-600 hover:text-red-800 flex items-center whitespace-nowrap">
                      <svg class="w-3 h-3 mr-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                      </svg> Quitar
                    </button>

                    <button v-if="isEditMode && currentPlanoUrl && !planoRemoved" type="button" @click="removeCurrentPlano" :disabled="processingLocal" class="text-[11px] text-orange-600 hover:text-orange-800 disabled:opacity-50 flex items-center">
                      <svg class="w-3 h-3 mr-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                      </svg> Eliminar actual
                    </button>

                    <span v-if="planoRemoved" class="text-[10px] text-gray-500 italic">Será eliminado</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="border border-gray-200 rounded-lg p-3 sm:p-4 bg-gradient-to-br from-blue-50 to-indigo-50">
              <div class="flex items-center justify-between mb-3">
                <h4 class="text-sm sm:text-base font-semibold text-gray-900 flex items-center">
                  <svg class="w-4 h-4 sm:w-5 sm:h-5 mr-2 text-blue-600 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path>
                  </svg>
                  <span>Encargados Adicionales</span>
                  <span class="ml-2 text-xs font-normal text-gray-500">(Opcional)</span>
                </h4>
              </div>

              <div v-if="isEditMode && encargadosExtra.length > 0" class="mb-4">
                <div class="bg-white rounded-lg border border-gray-200 overflow-hidden">
                  <table class="min-w-full divide-y divide-gray-200">
                    <thead class="bg-gray-50">
                      <tr>
                        <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase">Nombre</th>
                        <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase hidden sm:table-cell">Cargo</th>
                        <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase hidden md:table-cell">Contacto</th>
                        <th class="px-3 py-2 text-center text-xs font-medium text-gray-500 uppercase w-20">Acciones</th>
                      </tr>
                    </thead>
                    <tbody class="bg-white divide-y divide-gray-200">
                      <tr v-for="(encargado, index) in encargadosExtra" :key="encargado.id || `temp-${index}`" class="hover:bg-gray-50">
                        <td class="px-3 py-2 text-sm">
                          <div class="font-medium text-gray-900">{{ encargado.nombre }}</div>
                          <div class="text-xs text-gray-500 sm:hidden">{{ encargado.cargo || 'Sin cargo' }}</div>
                        </td>
                        <td class="px-3 py-2 text-sm text-gray-600 hidden sm:table-cell">
                          {{ encargado.cargo || 'Sin cargo' }}
                        </td>
                        <td class="px-3 py-2 text-sm text-gray-600 hidden md:table-cell">
                          <div v-if="encargado.telefono" class="flex items-center text-xs">
                            <svg class="w-3 h-3 mr-1 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
                            </svg>
                            {{ encargado.telefono }}
                          </div>
                          <div v-if="encargado.email" class="flex items-center text-xs mt-1">
                            <svg class="w-3 h-3 mr-1 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 002 2z"></path>
                            </svg>
                            {{ encargado.email }}
                          </div>
                        </td>
                        <td class="px-3 py-2 text-center">
                          <div class="flex items-center justify-center space-x-1">
                            <button type="button" @click="eliminarEncargadoExtra(index)" class="p-1.5 text-red-600 hover:bg-red-50 rounded transition-colors" title="Eliminar">
                              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
                              </svg>
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div v-if="nuevosEncargadosExtra.length > 0" class="space-y-3 mb-4">
                <div v-for="(encargado, index) in nuevosEncargadosExtra" :key="`nuevo-${index}`" class="bg-white border-2 border-blue-200 rounded-lg p-3 relative">
                  <div class="absolute -top-2 -right-2 bg-blue-500 text-white text-xs px-2 py-0.5 rounded-full font-medium">Nuevo</div>
                  <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    <div>
                      <label class="block text-xs font-medium text-gray-700 mb-1">
                        Nombre <span class="text-red-500">*</span>
                      </label>
                      <input v-model="encargado.nombre" type="text" required :disabled="processingLocal" class="w-full px-2 py-1.5 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors disabled:opacity-50" placeholder="Juan Erices">
                    </div>

                    <div>
                      <label class="block text-xs font-medium text-gray-700 mb-1">Cargo</label>
                      <input v-model="encargado.cargo" type="text" :disabled="processingLocal" class="w-full px-2 py-1.5 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors disabled:opacity-50" placeholder="Gerente de Local">
                    </div>

                    <div>
                      <label class="block text-xs font-medium text-gray-700 mb-1">Teléfono</label>
                      <input v-model="encargado.telefono" type="tel" maxlength="20" @input="formatTelefonoExtra(index)" :disabled="processingLocal" class="w-full px-2 py-1.5 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors disabled:opacity-50" placeholder="+56 9 1234 5678">
                    </div>

                    <div>
                      <label class="block text-xs font-medium text-gray-700 mb-1">Email</label>
                      <input v-model="encargado.email" type="email" :disabled="processingLocal" class="w-full px-2 py-1.5 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors disabled:opacity-50" placeholder="contacto@ejemplo.com">
                    </div>
                  </div>

                  <button type="button" @click="quitarNuevoEncargadoExtra(index)" :disabled="processingLocal" class="absolute top-2 right-2 p-1 text-red-600 hover:bg-red-50 rounded transition-colors disabled:opacity-50" title="Quitar">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                    </svg>
                  </button>
                </div>
              </div>

              <button type="button" @click="agregarNuevoEncargadoExtra" :disabled="processingLocal" class="w-full px-4 py-2.5 border-2 border-dashed border-blue-300 text-blue-600 rounded-lg hover:bg-blue-50 hover:border-blue-400 transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2 font-medium text-sm">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
                </svg>
                <span>Añadir Encargado Adicional</span>
              </button>
            </div>

            <div class="flex flex-col-reverse sm:flex-row gap-2 sm:gap-3 sm:justify-end pt-2">
              <button type="button" @click="hideLocalModal" :disabled="processingLocal" class="w-full sm:w-auto px-4 py-2.5 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition-colors disabled:opacity-50 font-medium text-sm">
                Cancelar
              </button>
              <button type="submit" :disabled="processingLocal || !isLocalFormValid" :class="[
                'w-full sm:w-auto px-5 py-2.5 rounded-lg focus:outline-none focus:ring-2 focus:ring-offset-2 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2 font-medium text-sm',
                isEditMode ?
                  'bg-yellow-600 text-white hover:bg-yellow-700 focus:ring-yellow-500' :
                  'bg-emerald-600 text-white hover:bg-emerald-700 focus:ring-emerald-500'
              ]">
                <svg v-if="processingLocal" class="animate-spin h-4 w-4" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                <span>{{ processingLocal ?
                  (isEditMode ? 'Actualizando...' : 'Creando...') :
                  (isEditMode ? 'Guardar' : 'Crear Local') }}</span>
              </button>
            </div>

          </form>
        </div>
      </div>
    </div>

    <div v-if="showDeleteModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-70 p-2">
      <div class="bg-white rounded-lg w-full max-w-lg max-h-[90vh] overflow-y-auto">

        <div class="bg-gradient-to-r from-red-600 to-red-700 text-white p-3 rounded-t-lg">
          <div class="flex items-center justify-between">
            <div class="flex items-center space-x-3">
              <div class="w-8 h-8 rounded-full bg-red-500 flex items-center justify-center">
                <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
                </svg>
              </div>
              <div>
                <h3 class="text-xl font-bold">Eliminar Local</h3>
              </div>
            </div>
            <button @click="hideDeleteModal" class="w-8 h-8 rounded-full bg-red-500 hover:bg-red-600 flex items-center justify-center transition-colors">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
              </svg>
            </button>
          </div>
        </div>

        <div class="p-4">

          <div v-if="loadingDeleteInfo" class="text-center py-8">
            <svg class="animate-spin h-8 w-8 text-red-600 mx-auto mb-4" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <p class="text-gray-600">Verificando dependencias del local...</p>
          </div>

          <div v-else-if="deleteInfo" class="space-y-6">

            <div class="bg-gray-50 rounded-lg p-2">
              <div class="grid grid-cols-1 gap-2 text-sm">
                <div class="flex justify-between">
                  <span class="text-gray-600">Número:</span>
                  <span class="font-medium">{{ deleteInfo.local.numero_local }}</span>
                </div>
                <div class="flex justify-between">
                  <span class="text-gray-600">Dirección:</span>
                  <span class="font-medium">{{ deleteInfo.local.direccion }}</span>
                </div>
                <div class="flex justify-between">
                  <span class="text-gray-600">Encargado:</span>
                  <span class="font-medium">{{ deleteInfo.local.encargado || 'Sin asignar' }}</span>
                </div>
                <div class="flex justify-between">
                  <span class="text-gray-600">Empresa:</span>
                  <span class="font-medium">{{ empresaNombre }}</span>
                </div>
              </div>
            </div>

            <div v-if="!deleteInfo.puedeEliminar" class="bg-red-50 border border-red-200 rounded-lg p-2">
              <div class="flex items-start space-x-3">
                <svg class="w-6 h-6 text-red-600 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.732 15.5c-.77.833.192 2.5 1.732 2.5z"></path>
                </svg>
                <div>
                  <h4 class="font-semibold text-red-800 mb-2">No se puede eliminar</h4>
                  <p class="text-red-700 mb-3">{{ deleteInfo.razonNoEliminar }}</p>

                  <div v-if="deleteInfo.dispositivos.length > 0" class="space-y-2">
                    <p class="font-medium text-red-800">Dispositivos asociados:</p>
                    <div class="bg-white rounded border max-h-32 overflow-y-auto">
                      <div v-for="dispositivo in deleteInfo.dispositivos" :key="dispositivo.id" class="px-3 py-2 border-b border-gray-200 last:border-b-0 text-sm">
                        <div class="flex justify-between items-center">
                          <span class="font-medium">{{ dispositivo.nombre_dispositivo }}</span>
                          <span :class="[
                            'px-2 py-1 rounded-full text-xs',
                            dispositivo.activo_dispositivo ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'
                          ]">
                            {{ dispositivo.activo_dispositivo ? 'Activo' : 'Inactivo' }}
                          </span>
                        </div>
                        <p class="text-gray-600 text-xs mt-1">{{ dispositivo.ubicacion_dispositivo }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-else-if="deleteInfo.advertencias.length > 0" class="bg-yellow-50 border border-yellow-200 rounded-lg p-2">
              <div class="flex items-start space-x-3">
                <svg class="w-6 h-6 text-yellow-600 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.732 15.5c-.77.833.192 2.5 1.732 2.5z"></path>
                </svg>
                <div>
                  <h4 class="font-semibold text-yellow-800 mb-2">Advertencias</h4>
                  <ul class="text-yellow-700 text-sm space-y-1">
                    <li v-for="advertencia in deleteInfo.advertencias" :key="advertencia" class="flex items-start">
                      <span class="mr-2">•</span>
                      <span>{{ advertencia }}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div v-else class="bg-green-50 border border-green-200 rounded-lg p-2">
              <div class="flex items-start space-x-3">
                <svg class="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
                <div>
                  <h4 class="font-semibold text-green-800 mb-2">Local listo para eliminar</h4>
                  <p class="text-green-700">El local no tiene dispositivos asociados y puede ser eliminado de forma segura.</p>
                </div>
              </div>
            </div>

            <div v-if="deleteInfo.puedeEliminar" class="space-y-3">
              <div class="border border-gray-200 rounded-lg p-2 bg-gray-50">
                <label class="block text-sm font-medium text-gray-700 mb-2">
                  Para confirmar, escribe "<strong>{{ deleteInfo.local.numero_local }}</strong>" en el campo:
                </label>
                <input v-model="deleteConfirmationText" type="text" :placeholder="`Escribe ${deleteInfo.local.numero_local} para confirmar`" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-red-500 focus:border-red-500 transition-colors" :class="isDeleteConfirmationValid ? 'border-green-500 bg-green-50' : ''">
              </div>
            </div>

            <div class="flex items-center justify-end">
              <button v-if="deleteInfo.puedeEliminar" @click="confirmarEliminacion" :disabled="processingDelete || !isDeleteConfirmationValid" class="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center space-x-2">
                <svg v-if="processingDelete" class="animate-spin h-4 w-4" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                <span>{{ processingDelete ? 'Eliminando...' : 'Eliminar Local Definitivamente' }}</span>
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { toast } from 'vue-sonner'

import LocalesService from '@/services/locales/locales.js'
import UsuariosService from '@/services/usuarios/usuarios.js'
import PermissionsService from '@/services/auth/permissions.js'
import EncargadosExtrasService from '@/services/usuarios/encargadosExtras.js'

export default {
  name: 'LocalesView',

  props: {
    empresa: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  emits: [
    'local-selected',
    'back-to-empresas'
  ],

  data() {
    return {
      locales: [],
      loadingLocales: false,
      // Estados de filtros
      searchText: '',
      selectedStatus: '',
      selectedEncargado: '',
      sortColumn: 'numero_local',
      sortDirection: 'desc',
      // Estados de dropdown
      dropdownOpen: {
        estado: false,
        encargado: false,
      },
      // Estados del modal
      showLocalModal: false,
      processingLocal: false,
      loadingEncargados: false,
      encargadosDisponibles: [],
      // Estados del modal de eliminación
      showDeleteModal: false,
      processingDelete: false,
      loadingDeleteInfo: false,
      deleteInfo: null,
      localToDelete: null,
      deleteConfirmationText: '',
      // Estados de modo de operación
      isEditMode: false,
      localToEdit: null,
      // Estados para manejo de imágenes
      selectedFile: null,
      imagePreview: null,
      currentImageUrl: null,
      imageRemoved: false,
      selectedPlanoFile: null,
      planoPreview: null,
      currentPlanoUrl: null,
      planoRemoved: false,
      // Estados para encargados extra
      encargadosExtra: [],
      nuevosEncargadosExtra: [],
      encargadosExtraAEliminar: [],
      encargadoExtraEnEdicion: null,
      // Formulario unificado
      localForm: {
        numero_local: '',
        direccion: '',
        plano_filas: 10,
        plano_columnas: 10,
        id_encargado: ''
      },
      // Estados existentes
      error: null,
      // Control del dropdown secundario
      activeSecondaryMenu: null
    }
  },

  computed: {
    // ========================================
    // PERMISOS COMPUTADOS
    puedeCrearLocales() {
      return PermissionsService.can('locales', 'crear')
    },

    puedeEditarLocales() {
      return PermissionsService.can('locales', 'editar')
    },

    puedeEliminarLocales() {
      return PermissionsService.can('locales', 'eliminar')
    },

    puedeVerTodosLocales() {
      return PermissionsService.can('locales', 'ver_todos')
    },

    puedeVerPropiosLocales() {
      return PermissionsService.can('locales', 'ver_propios')
    },

    mensajePermisos() {
      if (!this.puedeVerTodosLocales && this.puedeVerPropiosLocales) {
        return 'Mostrando solo los locales donde eres encargado'
      }
      return null
    },

    tieneAccesoGestionLocales() {
      return this.puedeCrearLocales || this.puedeEditarLocales || this.puedeEliminarLocales
    },

    // ========================================
    empresaNombre() {
      return this.empresa?.nombre_empresa || this.empresa?.nombre || 'Empresa'
    },
    empresaLogo() {
      return this.empresa?.media || null
    },
    isLoading() {
      return this.loading || this.loadingLocales
    },

    /**
     * Validación del formulario
     */
    isLocalFormValid() {
      return this.localForm.numero_local.trim() &&
        this.localForm.direccion.trim()
    },

    /**
     * Estadísticas usando el servicio
     */
    estadisticas() {
      return LocalesService.obtenerEstadisticasLocales(this.locales)
    },

    /**
     * Locales filtrados según criterios de búsqueda
     */
    localesFiltrados() {
      let result = [...this.locales]

      // Filtro de búsqueda de texto
      if (this.searchText) {
        const search = this.searchText.toLowerCase()
        result = result.filter(local =>
          local.numero_local.toString().toLowerCase().includes(search) ||
          local.direccion.toLowerCase().includes(search) ||
          local.encargado.toLowerCase().includes(search)
        )
      }

      // Filtro por estado
      if (this.selectedStatus) {
        result = result.filter(local => {
          const status = this.getLocalStatus(local).toLowerCase()
          return status === this.selectedStatus
        })
      }

      // Filtro por encargado
      if (this.selectedEncargado) {
        if (this.selectedEncargado === 'sin_encargado') {
          result = result.filter(local => !local.tiene_encargado)
        } else if (this.selectedEncargado === 'con_encargado') {
          result = result.filter(local => local.tiene_encargado)
        }
      }

      return result
    },

    /**
     * Locales filtrados y ordenados
     */
    localesSorted() {
      let result = [...this.localesFiltrados];

      result.sort((a, b) => {
        let modifier = this.sortDirection === 'desc' ? -1 : 1;
        let valA = a[this.sortColumn];
        let valB = b[this.sortColumn];

        if (this.sortColumn === 'numero_local') {
          valA = Number(valA);
          valB = Number(valB);
        } else if (typeof valA === 'string') {
          valA = valA.toLowerCase();
          valB = valB ? valB.toLowerCase() : '';
        }

        if (valA < valB) return -1 * modifier;
        if (valA > valB) return 1 * modifier;
        return 0;
      });

      return result;
    },

    /**
     * Verifica si hay filtros activos
     */
    hasActiveFilters() {
      return !!(this.searchText || this.selectedStatus || this.selectedEncargado)
    },

    /**
     * Valida la confirmación de eliminación
     */
    isDeleteConfirmationValid() {
      return this.deleteInfo &&
        this.deleteConfirmationText.trim() === this.deleteInfo.local.numero_local.toString()
    }
  },

  methods: {
    // ---------------------------------------------------
    // Gestión de Datos de Locales (CRUD)
    // ---------------------------------------------------
    async loadLocales() {
      if (!this.empresa?.id) return

      this.loadingLocales = true
      this.error = null

      try {
        let locales = await LocalesService.obtenerLocalesPorEmpresa(this.empresa.id)

        // Aplica filtros de permisos según el usuario
        if (!this.puedeVerTodosLocales && this.puedeVerPropiosLocales) {
          const usuarioActualId = PermissionsService.getUserId()
          if (usuarioActualId) {
            locales = locales.filter(local => local.id_encargado === usuarioActualId)
          }
        }

        this.locales = locales

      } catch (error) {
        this.error = error.message
        this.locales = []
        toast.error(`Error cargando locales: ${error.message}`)
      } finally {
        this.loadingLocales = false
      }
    },

    async createLocal() {
      this.processingLocal = true
      try {
        const datosLocal = {
          ...this.localForm,
          id_empresa: this.empresa.id,
          id_encargado: this.localForm.id_encargado || null
        }

        // Pasamos el plano como tercer parámetro (si es null, el servicio sabrá qué hacer)
        const localCreado = await LocalesService.crearLocal(
          datosLocal,
          this.selectedFile,
          this.selectedPlanoFile
        )

        if (this.nuevosEncargadosExtra.length > 0) {
          await EncargadosExtrasService.crearEncargadosEnLote(this.nuevosEncargadosExtra, localCreado.id)
        }

        toast.success(`Local "${localCreado.numero_local}" creado exitosamente`, localCreado)
        this.hideLocalModal()
        await this.loadLocales()
      } catch (error) {
        toast.error(error.message)
      } finally {
        this.processingLocal = false
      }
    },

    async updateLocal() {
      this.processingLocal = true
      try {
        const datosLocal = {
          ...this.localForm,
          id_empresa: this.empresa.id,
          id_encargado: this.localForm.id_encargado || null
        }

        const localActualizado = await LocalesService.actualizarLocal(
          this.localToEdit.id,
          datosLocal,
          this.selectedFile,
          this.imageRemoved,
          this.selectedPlanoFile,
          this.planoRemoved
        )

        if (this.encargadosExtraAEliminar.length > 0) {
          for (const id of this.encargadosExtraAEliminar) {
            await EncargadosExtrasService.eliminarEncargado(id)
          }
        }

        if (this.nuevosEncargadosExtra.length > 0) {
          await EncargadosExtrasService.crearEncargadosEnLote(
            this.nuevosEncargadosExtra,
            this.localToEdit.id
          )
        }

        toast.success(`Local "${localActualizado.numero_local}" actualizado exitosamente`, localActualizado)
        this.hideLocalModal()
        await this.loadLocales()
      } catch (error) {
        toast.error(error.message)
      } finally {
        this.processingLocal = false
      }
    },

    handlePlanoSelect(event) {
      const file = event.target.files[0]
      if (!file) {
        this.clearSelectedPlano()
        return
      }
      try {
        LocalesService.validarArchivoImagen(file)
        this.selectedPlanoFile = file

        const reader = new FileReader()
        reader.onload = (e) => {
          this.planoPreview = e.target.result
        }
        reader.readAsDataURL(file)
      } catch (error) {
        this.showError(`Error en el plano: ${error.message}`)
        this.clearSelectedPlano()
      }
    },

    removeCurrentPlano() {
      this.planoRemoved = true;
      this.currentPlanoUrl = null;
    },

    clearSelectedPlano() {
      this.selectedPlanoFile = null
      this.planoPreview = null
      if (this.$refs.planoInput) {
        this.$refs.planoInput.value = ''
      }
    },

    async submitLocalForm() {
      if (!this.isLocalFormValid) {
        toast.error('Por favor completa todos los campos requeridos')
        return
      }
      if (this.isEditMode) {
        await this.updateLocal()
      } else {
        await this.createLocal()
      }
    },

    async loadEncargadosDisponibles() {
      if (this.loadingEncargados) return
      this.loadingEncargados = true
      try {
        this.encargadosDisponibles = await UsuariosService.obtenerEncargados()
      } catch (error) {
        this.showError('No se pudieron cargar los encargados disponibles')
        this.encargadosDisponibles = []
      } finally {
        this.loadingEncargados = false
      }
    },

    // ---------------------------------------------------
    // Gestión de Encargados Extra
    // ---------------------------------------------------
    agregarNuevoEncargadoExtra() {
      this.nuevosEncargadosExtra.push({
        nombre: '',
        telefono: '',
        email: '',
        cargo: ''
      })
    },

    quitarNuevoEncargadoExtra(index) {
      this.nuevosEncargadosExtra.splice(index, 1)
    },

    async cargarEncargadosExtraDelLocal(localId) {
      try {
        this.encargadosExtra = await EncargadosExtrasService.obtenerEncargadosPorLocal(localId)
      } catch (error) {
        this.encargadosExtra = []
      }
    },

    editarEncargadoExtra(index) {
      // En modo edición, permitir editar in-place
      // Por ahora, solo mostraremos un alert
      const encargado = this.encargadosExtra[index]
      alert(`Editar encargado: ${encargado.nombre}\n\nEsta funcionalidad estará disponible próximamente.`)
    },

    eliminarEncargadoExtra(index) {
      const encargado = this.encargadosExtra[index]

      // Si tiene ID, marcarlo para eliminación
      if (encargado.id) {
        this.encargadosExtraAEliminar.push(encargado.id)
      }
      // Remover de la lista visual
      this.encargadosExtra.splice(index, 1)
    },

    formatTelefonoExtra(index) {
      let input = this.nuevosEncargadosExtra[index].telefono

      // Limpiar todo excepto números y +
      let digits = input.replace(/[^\d+]/g, '')

      if (digits.length === 0) {
        this.nuevosEncargadosExtra[index].telefono = ''
        return
      }

      // Formato básico +56 9 1234 5678
      if (digits.startsWith('+56') || digits.startsWith('56')) {
        // Remover espacios antiguos
        digits = digits.replace(/\s/g, '')

        // Forzar +56
        if (!digits.startsWith('+')) {
          if (digits.startsWith('56')) {
            digits = '+' + digits
          } else {
            digits = '+56' + digits
          }
        }

        // Limitar longitud (máximo +56 9 1234 5678 = 12 caracteres sin espacios)
        if (digits.length > 12) {
          digits = digits.substring(0, 12)
        }

        // Aplicar formato progresivo
        let formatted = ''

        // Siempre incluir +56
        formatted = digits.substring(0, Math.min(3, digits.length)) // +56

        // Si hay más de 3 caracteres, agregar el 9 con espacio
        if (digits.length > 3) {
          formatted += ' ' + digits.substring(3, Math.min(4, digits.length)) // 9
        }

        // Si hay más de 4 caracteres, agregar los siguientes 4 dígitos con espacio
        if (digits.length > 4) {
          formatted += ' ' + digits.substring(4, Math.min(8, digits.length)) // 1234
        }

        // Si hay más de 8 caracteres, agregar los últimos 4 dígitos con espacio
        if (digits.length > 8) {
          formatted += ' ' + digits.substring(8, Math.min(12, digits.length)) // 5678
        }

        this.nuevosEncargadosExtra[index].telefono = formatted
      } else {
        // Formato genérico para otros países
        if (digits.length > 20) {
          digits = digits.substring(0, 20)
        }
        this.nuevosEncargadosExtra[index].telefono = digits
      }
    },

    // ---------------------------------------------------
    // Gestión de Modales y Formularios
    // ---------------------------------------------------
    async showCreateForm() {
      this.isEditMode = false
      this.localToEdit = null
      this.localForm = {
        numero_local: '',
        direccion: '',
        id_encargado: ''
      }
      this.selectedFile = null
      this.imagePreview = null
      this.currentImageUrl = null
      this.imageRemoved = false

      // Limpiar encargados extra
      this.encargadosExtra = []
      this.nuevosEncargadosExtra = []
      this.encargadosExtraAEliminar = []

      if (this.encargadosDisponibles.length === 0) {
        await this.loadEncargadosDisponibles()
      }

      this.showLocalModal = true
      this.$nextTick(() => {
        const firstInput = document.querySelector('input[type="text"]')
        if (firstInput) firstInput.focus()
      })
    },

    async editLocal(local) {
      this.isEditMode = true
      this.selectedPlanoFile = null
      this.planoPreview = null
      this.currentPlanoUrl = null
      this.planoRemoved = false
      this.localToEdit = local
      this.localForm = {
        numero_local: local.numero_local.toString(),
        direccion: local.direccion,
        id_encargado: local.id_encargado || ''
      }

      if (local.media) {
        this.currentImageUrl = this.getImageUrl(local.media)
      } else {
        this.currentImageUrl = null
      }

      this.selectedFile = null
      this.imagePreview = null
      this.imageRemoved = false

      // Cargar encargados extra del local
      this.nuevosEncargadosExtra = []
      this.encargadosExtraAEliminar = []
      await this.cargarEncargadosExtraDelLocal(local.id)

      if (this.encargadosDisponibles.length === 0) {
        await this.loadEncargadosDisponibles()
      }

      // Intentamos cargar el plano actual del local
      try {
        const planoActual = await LocalesService.obtenerPlanoLocal(local.id);
        if (planoActual && planoActual.archivo_url) {
          this.currentPlanoUrl = planoActual.archivo_url;
          this.planoPreview = planoActual.archivo_url; // Mostrar preview visual
          this.localForm.plano_filas = planoActual.filas || 10;
          this.localForm.plano_columnas = planoActual.columnas || 10;
        }
      } catch (e) {
        // Si no tiene plano (404), simplemente pasamos de largo
      }
      this.showLocalModal = true
      this.$nextTick(() => {
        const firstInput = document.querySelector('input[type="text"]')
        if (firstInput) firstInput.focus()
      })

    },

    hideLocalModal() {
      this.showLocalModal = false
      this.resetLocalForm()
    },

    resetLocalForm() {
      this.localForm = {
        numero_local: '',
        direccion: '',
        id_encargado: ''
      }
      this.clearSelectedFile()
      this.currentImageUrl = null
      this.imageRemoved = false
      this.processingLocal = false
      this.isEditMode = false
      this.localToEdit = null

      // Limpiar encargados extra
      this.encargadosExtra = []
      this.nuevosEncargadosExtra = []
      this.encargadosExtraAEliminar = []
      this.currentPlanoUrl = null;
      this.planoRemoved = false;
    },

    // ---------------------------------------------------
    // Gestión de Imágenes y Archivos
    // ---------------------------------------------------
    handleFileSelect(event) {
      const file = event.target.files[0]
      if (!file) {
        this.clearSelectedFile()
        return
      }
      try {
        LocalesService.validarArchivoImagen(file)
        this.selectedFile = file
        this.createImagePreview(file)
        this.imageRemoved = false
      } catch (error) {
        this.showError(error.message)
        event.target.value = ''
        this.clearSelectedFile()
      }
    },

    createImagePreview(file) {
      const reader = new FileReader()
      reader.onload = (e) => {
        this.imagePreview = e.target.result
      }
      reader.readAsDataURL(file)
    },

    clearSelectedFile() {
      this.selectedFile = null
      this.imagePreview = null
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = ''
      }
    },

    removeCurrentImage() {
      this.imageRemoved = true
      this.currentImageUrl = null
    },

    getImageUrl(mediaPath) {
      return LocalesService.obtenerUrlImagen(mediaPath)
    },

    handleImageError(event, local) {
      event.target.style.display = 'none'
      local._imageError = true
    },

    // ---------------------------------------------------
    // Gestión de Eliminación de Locales
    // ---------------------------------------------------
    async iniciarEliminacionLocal(local) {
      this.localToDelete = local
      this.deleteInfo = null
      this.deleteConfirmationText = ''
      this.loadingDeleteInfo = true
      this.showDeleteModal = true

      try {
        this.deleteInfo = await LocalesService.obtenerInfoEliminacion(local.id)
      } catch (error) {
        toast.error(`Error verificando dependencias: ${error.message}`)
        this.hideDeleteModal()
      } finally {
        this.loadingDeleteInfo = false
      }
    },

    async confirmarEliminacion() {
      if (!this.isDeleteConfirmationValid) {
        toast.info('Por favor confirma escribiendo el número del local correctamente')
        return
      }
      this.processingDelete = true
      try {
        await LocalesService.eliminarLocal(this.localToDelete.id)
        toast.success(
          `Local "${this.localToDelete.numero_local}" eliminado exitosamente.\n` +
          `\nDirección: ${this.localToDelete.direccion}\n` +
          `La eliminación es definitiva y no se puede deshacer.`
        )
        this.hideDeleteModal()
        await this.loadLocales()
      } catch (error) {
        if (error.codigo === 'LOCAL_HAS_DEVICES') {
          toast.error(
            `No se puede eliminar el local:\n\n${error.message}\n\n` +
            `Dispositivos encontrados: ${error.cantidadDispositivos}`
          )
          this.iniciarEliminacionLocal(this.localToDelete)
        } else {
          toast.warning(`Error eliminando local: ${error.message}`)
        }
      } finally {
        this.processingDelete = false
      }
    },

    hideDeleteModal() {
      this.showDeleteModal = false
      this.resetDeleteForm()
    },

    resetDeleteForm() {
      this.deleteInfo = null
      this.localToDelete = null
      this.deleteConfirmationText = ''
      this.processingDelete = false
      this.loadingDeleteInfo = false
    },

    // ---------------------------------------------------
    // Gestión de Filtros y Dropdowns
    // ---------------------------------------------------
    toggleDropdown(tipo) {
      Object.keys(this.dropdownOpen).forEach(key => {
        if (key !== tipo) this.dropdownOpen[key] = false
      })
      this.dropdownOpen[tipo] = !this.dropdownOpen[tipo]
    },

    selectOption(tipo, valor) {
      if (tipo === 'estado') {
        this.selectedStatus = valor
      } else if (tipo === 'encargado') {
        this.selectedEncargado = valor
      }
      this.dropdownOpen[tipo] = false
    },

    closeAllDropdowns() {
      Object.keys(this.dropdownOpen).forEach(key => {
        this.dropdownOpen[key] = false
      })
    },

    clearAllFilters() {
      this.searchText = ''
      this.selectedStatus = ''
      this.selectedEncargado = ''
      this.closeAllDropdowns()
    },

    toggleSecondaryMenu(localId) {
      if (this.activeSecondaryMenu === localId) {
        this.activeSecondaryMenu = null
      } else {
        this.activeSecondaryMenu = localId
      }
    },

    closeSecondaryMenus() {
      this.activeSecondaryMenu = null
    },

    handleClickOutside(event) {
      if (!event.target.closest('.relative')) {
        this.closeSecondaryMenus()
      }
    },

    sortBy(column) {
      if (this.sortColumn === column) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortColumn = column;
        this.sortDirection = 'asc';
      }
    },
    // ---------------------------------------------------
    // Utilidades y Helpers
    // ---------------------------------------------------
    selectLocal(local) {
      this.$emit('local-selected', local)
    },

    getLocalStatus(local) {
      return local.estado
    },

    getLogoText(local) {
      if (local.media && !local._imageError) return ''
      if (local.numero_local) return local.numero_local.toString().substring(0, 3).toUpperCase()
      return this.empresaNombre.substring(0, 3).toUpperCase()
    },

    getStatusClasses(local) {
      const status = this.getLocalStatus(local)
      switch (status) {
        case 'Operativo': return 'bg-green-100 text-green-800'
        case 'Advertencia': return 'bg-yellow-100 text-yellow-800'
        case 'Error': return 'bg-red-100 text-red-800'
        default: return 'bg-gray-100 text-gray-800'
      }
    },

    getStatusIconColor(local) {
      const status = this.getLocalStatus(local)
      switch (status) {
        case 'Operativo': return 'text-green-400'
        case 'Advertencia': return 'text-yellow-400'
        case 'Error': return 'text-red-400'
        default: return 'text-gray-400'
      }
    },

    getEmpresaColor() {
      const colors = [
        '#3B82F6', '#10B981', '#F59E0B', '#EF4444',
        '#8B5CF6', '#06B6D4', '#84CC16', '#F97316'
      ]
      const empresaName = this.empresaNombre
      let hash = 0
      for (let i = 0; i < empresaName.length; i++) {
        hash = empresaName.charCodeAt(i) + ((hash << 5) - hash)
      }
      return colors[Math.abs(hash) % colors.length]
    },

    mostrarMensajeExito(mensaje, local) {
      let mensajeCompleto = mensaje
      if (local.encargado && local.encargado !== 'Sin asignar') {
        mensajeCompleto += `\nEncargado: ${local.encargado}`
      } else {
        mensajeCompleto += `\nSin encargado asignado`
      }
      if (local.media) mensajeCompleto += '\nLogo cargado correctamente'
      this.showSuccess(mensajeCompleto)
    },

    showSuccess(message) {
      alert(`${message}`)
    },

    showError(message) {
      alert(`${message}`)
    }
  },

  mounted() {
    this.loadLocales()

    document.addEventListener('click', this.handleClickOutside)

    window.addEventListener('resize', () => {
      if (window.innerWidth >= 1024) {
        this.showFilters = true
      }
    })
  },

  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside)
  },

  watch: {
    empresa: {
      handler(newEmpresa) {
        if (newEmpresa) {
          this.loadLocales()
        }
      },
      immediate: false
    },

    showLocalModal: {
      async handler(isOpen) {
        if (isOpen && this.encargadosDisponibles.length === 0) {
          await this.loadEncargadosDisponibles()
        }
      }
    }
  }
}
</script>

<style scoped>
/* Transiciones para la tabla */
.table-row-enter-active,
.table-row-leave-active {
  transition: all 0.3s ease;
}

.table-row-enter-from {
  opacity: 0;
  transform: translateY(10px);
}

.table-row-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

/* Hover effects para las filas */
tr:hover {
  background-color: #eff6ff;
}

/* Loading skeleton personalizado */
@keyframes pulse {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.5;
  }
}

.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

/* Estilo para el icono de localización */
.location-icon {
  color: #ef4444;
}

/* Estilos responsive mejorados */
@media (max-width: 640px) {
  .table-container {
    overflow-x: auto;
  }

  .mobile-stack {
    display: block;
  }

  .mobile-stack td {
    display: block;
    text-align: left;
    border: none;
    padding: 0.5rem 1rem;
  }

  .mobile-stack td:before {
    content: attr(data-label);
    font-weight: bold;
    display: inline-block;
    width: 100px;
  }
}

/* Animaciones de modal */
.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.3s ease;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

.modal-content-enter-active,
.modal-content-leave-active {
  transition: transform 0.3s ease;
}

.modal-content-enter-from,
.modal-content-leave-to {
  transform: scale(0.9) translateY(-10px);
}

/* Animaciones para filtros */
.filter-enter-active,
.filter-leave-active {
  transition: all 0.3s ease;
}

.filter-enter-from,
.filter-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

/* Chips de filtros */
.chip-enter-active,
.chip-leave-active {
  transition: all 0.2s ease;
}

.chip-enter-from,
.chip-leave-to {
  opacity: 0;
  transform: scale(0.8);
}
</style>